// List faq urls
import faqUrls from '@/lib/urls/faqUrls';

const BASE_FAQ_URL = process.env.NEXT_PUBLIC_BASE_FAQ_URL ?? '';

/**
 * Build FAQ URL. For locale 'fr', inserts /fr/ before the slug (e.g. support.iconosquare.com/fr/...).
 */
const faqUrl = (key: keyof typeof faqUrls, locale?: string) => {
    const base = BASE_FAQ_URL.replace(/\/$/, '');
    if (!(key in faqUrls) || !faqUrls[key as keyof typeof faqUrls]) {
        return base;
    }
    const slug = faqUrls[key as keyof typeof faqUrls];
    const path = locale === 'fr' ? `fr/${slug}` : slug;
    return `${base}/${path}`;
};

export default faqUrl;
